import Text from 'components/shared/Typography/Text';

import s from './TabSelector.module.css';
import * as t from './TabSelector.types';

export const TabLabel = (props: t.TabLabelProps) => (
  <div className={s.tabLabel}>
    <props.Icon size={22} className={s.tabLabelIcon} />
    <Text className={s.tabLabelText} size="regular" type="brandon">
      {props.text}
    </Text>
  </div>
);
